import { render } from "./ContratacaoDetalheView.vue?vue&type=template&id=e24a1958&scoped=true"
import script from "./ContratacaoDetalheView.vue?vue&type=script&lang=js"
export * from "./ContratacaoDetalheView.vue?vue&type=script&lang=js"

import "./ContratacaoDetalheView.vue?vue&type=style&index=0&id=e24a1958&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e24a1958"]])

export default __exports__